import { wordService } from "../services/wordService";

export const applyAuthor = () => wordService.applySemanticTag({ type: "author", styleBuiltIn: "Normal" });
